import React from 'react';
import { useTranslation } from 'react-i18next';

import { Kpi, KpiLabel, KpiSub, KpiValue, Kpis } from '../styles';
import { formatNumber, metricLabel } from '../config';

// Şablonun hesaplanan metrikleri (analitik yanıt şeması): değer, pay/payda ya da n; küçük grup gizlemesi "Gizlendi", payda 0 "Veri Yok".
export default function MetricStrip({ metrics }) {
  const { t, i18n } = useTranslation();
  if (!metrics || metrics.length === 0) return null;
  return (
    <Kpis data-section="metrics">
      {metrics.map((m) => {
        let value;
        if (m.suppressionReason) value = t('performance.reportCenter.suppressed');
        else if (m.value == null) value = t('performance.reportCenter.noData');
        else value = `${formatNumber(m.value, i18n.language)}${m.unit === 'percent' ? '%' : ''}`;
        const sub = !m.suppressionReason && m.value != null && m.numerator != null && m.denominator != null
          ? t('performance.reportCenter.ratio', { num: formatNumber(m.numerator, i18n.language, 0), den: formatNumber(m.denominator, i18n.language, 0) })
          : null;
        return (
          <Kpi key={m.metricCode} data-metric={m.metricCode}>
            <KpiLabel title={metricLabel(t, m.metricCode)}>{metricLabel(t, m.metricCode)}</KpiLabel>
            <KpiValue data-value={m.metricCode}>{value}</KpiValue>
            {sub ? <KpiSub>{sub}</KpiSub> : null}
          </Kpi>
        );
      })}
    </Kpis>
  );
}
